// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Servicos_BuscarServicosResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/servicos/buscar_servicos
 *
 * Returns a list of every service joined with its category, plus a
 * controller-injected `categoria` display field. Legacy shape emits the
 * array directly under `dados`.
 */
import type { Servicos_ServicoRow } from './Servicos_ServicoRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Servicos_BuscarServicosResponseDados = Servicos_ServicoRow[];

export type Servicos_BuscarServicosResponse = ApiResponse<Servicos_BuscarServicosResponseDados>;

registerResponseContract('Servicos_BuscarServicosResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      servico_id:             { type: 'number',  required: true },
      servico_nome:           { type: 'string',  required: true },
      servico_valor_padrao:   { type: 'number',  required: true },
      servicoscategoria_id:   { type: 'string',  required: true },
      servicocategoria_id:    { type: 'string',  required: false },
      servicoscategoria_nome: { type: 'string',  required: false },
      categoria:              { type: 'string',  required: false },
    },
  },
})
